/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription, filter, map } from "rxjs";
import { EnvConfigService } from './env-config.service'
import { environment, FeaturesSettings } from "../environments/environment";
import { DataService } from "./admin/data.service";
import { ApiService } from "./admin/api.service";
import { CommonapiService } from "./commonapi.service";
import { FirebasemessagingService } from "./firebasemessaging.service";
import { NbDialogService } from "@nebular/theme";

@Component({
  selector: "ngx-app",
  template: `<router-outlet></router-outlet>
    <ng-template class="dialogBox" #notification let-data let-ref="dialogRef">
      <nb-card class="notificationBox">
        <nb-card-header>{{ notificationTitle }}</nb-card-header>
        <nb-card-body>{{ notificationBody }}</nb-card-body>
        <nb-card-footer>
          <button type="submit" nbButton status="danger" class="notification" (click)="closeNotification()">Close</button>
        </nb-card-footer>
      </nb-card>
    </ng-template>`,
  styles: [`
    .notificationBox{
      width : 30vw;
    }
    .notification{
      width : 100px
    }`
  ]
})
export class AppComponent implements OnInit {
  private routerSubscription: Subscription;
  baseUrl = environment.BASEURL
  private readonly fallbackFavicon: string = 'assets/images/favicon.png';
  notificationTitle : any;
  notificationBody : any;
  @ViewChild("notification") notification: TemplateRef<any>;
  notificationClose: import("@nebular/theme").NbDialogRef<any>;

  constructor(
    public translate: TranslateService,
    private dataService : DataService,
    private apiservice : ApiService,
    private commonapi : CommonapiService,
    private readonly router: Router,
    private readonly envService: EnvConfigService,
    private firebasemessaging : FirebasemessagingService,
    private readonly dialogService: NbDialogService,
  ) {
    // Theme color
    this.dataService.updateColor()

    // Initial language setup
    // const language = sessionStorage.getItem('language') || LanguageSettings.defaultSelectedLang;
    // this.translate.addLangs(LanguageSettings.languages);
    // this.translate.use(language);
    // translate.setDefaultLang(language);

    // Subscribe to loading state changes to trigger re-translation only when language changes
    // this.interceptorService.loading$
    //   .pipe(distinctUntilChanged())  // Only emit when the value changes
    //   .subscribe((loading) => {
    //     if (loading !== this.previousCondition) {  // Only execute when the value changes
    //       console.log(loading, "language change app component");
    //       const currentLang = sessionStorage.getItem('language') || LanguageSettings.defaultSelectedLang;
    //       this.translate.use(currentLang);
    //       translate.setDefaultLang(language);
    //       this.previousCondition = loading;  // Update previous condition to the new state
    //     }
    //   });
  }


  ngOnInit(): void {
    const dynamicFavicon = this.envService.getEnvData();
    const dynamicFaviconLink = this.baseUrl + dynamicFavicon?.app?.favicon || this.fallbackFavicon
    this.envService.setFavicon(dynamicFaviconLink);

    
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {

          const urlList = this.router.url.split('/');
          const lastUrlSegment = urlList[urlList.length - 1];
          console.log(lastUrlSegment)
          if(lastUrlSegment.startsWith('installation')) {
           this.envService.isInstallation$.subscribe((res)=>{
            console.log(res)
            if(res){
              console.log('Installation completed, redirecting...');
              this.router.navigate(["/admin/dashboard"]);
            }else{
              console.log('Installation not completed, redirecting...');
              this.router.navigate(["/installation"])
            }
           })
          }
          if (lastUrlSegment.startsWith('auth')) {
            this.router.navigate(['/admin/dashboard']);
            return '';
          } else if (lastUrlSegment == 'company-login') {
            this.router.navigate(['/company/dashboard']);
          }
          // if(lastUrlSegment == 'auth' || lastUrlSegment == 'login'){
          //   this.authService.setLoginInfo(null)
          // }
          return urlList[urlList.length - 1];
        })
      )
      .subscribe((title) => {
        console.log(title)
      })
      this.firebasemessaging.listenForMessages();

      this.firebasemessaging.currentMessage.subscribe((message) => {
        if (message && message.notification) {
          this.notificationTitle = message.notification.title;
          this.notificationBody = message.notification.body;
          this.openChangePasswordDialog(this.notification)
        }
      });
  }

  openChangePasswordDialog(dialog: TemplateRef<any>) {
    this.notificationClose = this.dialogService.open(dialog, {
      autoFocus: false,
      closeOnBackdropClick: FeaturesSettings.Nb_dialogbox_close_while_click_outside,
      dialogClass: 'top-dialog'
    });
  }

  closeNotification(){
    this.notificationClose.close();
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.notificationClose) {
      this.notificationClose.close();
    }
  }
}
